let host = location.host;
let TestSite = ['store-rev.modd.com'];

const activeClass = 'js-active';

interface JQuery {
    aemAccordion(...any);
}

$(function(){
    $('title').html('えだりょオフィシャルファンクラブ '); 
})


$(function () {
    let $body = $('body');
    let bodyId = $body.attr('id');

    if (bodyId === 'RegisterStep1') {
        RegisterStep1();
    } else if (bodyId === 'MyPage') {
        MyPage();
    } else if (bodyId === 'CustomerEditFin') {
        CustomerEditFin();
    } else if (bodyId === 'com_kiyaku') {
        com_kiyaku();
    } else if (bodyId === 'com_contact') {
        com_contact();
    } else if (bodyId === 'com_help') {
        com_help();
    } else if (bodyId === 'Login') {
        Login();
    } else if (bodyId === 'privacy') {
        privacy();
    } else if (bodyId === 'fc_help') {
        fc_help();
    }

    addWrapperElement();
    initAccordion();
    controlLoginElement();
});


// RegisterStep1
function RegisterStep1() {
    $('.table_label.col_must').each(function(){
        let $title = $(this);

        if($title.text().indexOf('郵便番号') > -1) {
            $title.append('<div class="c-red">※ハイフンなしの半角数字で入力してください。</div>');
        }
    });
}

// MyPage
function MyPage() {
    // アコーディオンを開いておく
    $('.table_collapse_link').removeClass('collapsed').attr('aria-expanded', 'true');
    $('.glyphicon').removeClass('glyphicon-chevron-left').addClass('glyphicon-chevron-down');
    $('.table_collapse').addClass('in');
}

// CustomerEditFin
function CustomerEditFin() {
    $('.alert-success').text('会員情報を変更しました。');
}

// com_kiyaku
function com_kiyaku() {
    $('#ec_lnk').text('利用規約はこちら');
}

// com_contact
function com_contact() {
    // 通販に関するお問合せはこちらを削除
    $('.com_panel').each(function (i) {
        if (i == 0) {
            $(this).hide();
        }
    });
}

// com_help
function com_help() {
    // 通販に関するご利用ガイドはこちらを削除
    $('.com_panel').each(function (i) {
        if (i == 0) {
            $(this).hide();
        }
    });
}

// アコーディオン
function initAccordion() {
    $('.js-accordion').aemAccordion({
        toggleCallback: function() {
            $(this).parent('.js-accordion').toggleClass(activeClass);
        }
    });
}

// Login
function Login() {
    $('.title_bar').remove();
    $('.panel').addClass('panel-main panel-main-1');

    $('.fc_register_table').hide();
}

// privacy
function privacy() {
    // プライバシーポリシーページの場合はリダイレクト
    if (location.href.indexOf('privacy.aspx') != -1) {
        $('body, html').hide();
        location.href = 'https://www.axelentermedia.co.jp/privacypolicy/';
    }
}

// fc_help
function fc_help() {
    $('.t_title').text('よくある質問');
}

// 背景要素追加
function addWrapperElement() {
    $('#wrapper').append('<div class="wrapper__bg"></div>')
}

// 会員登録・新規入会エリアの削除・複製
function controlLoginElement() {
    $('.sinki_table').find('.panel-main-1').find('#sinki_annnounce').remove();
    $('.sinki_table').find('.panel-main-1').find('.fc_join_panel.register_linktype1').remove();
    $('.sinki_table').append('<div class="panel panel-default panel-main panel-main-2"><div id="sinki_annnounce" class="panel-heading sinki_header_fc register_linktype1">ファンクラブ（有料）への入会を希望する方はこちら</div><div class="panel-body sinki_body fc_join_panel register_linktype1"><a id="fcJoin_lnk" class="btn btn-default fc_sinki_button" href="fcJoin.aspx?ccode=RYFC"></a></div></div>')
    $('.guest_table').remove();
}